import React from "react";
import { useUrl } from "@/context/SiteContext";
import ServicePage from "./ServicePage";

export default function ProiectInformaticDigitalizarePage() {
  const url = useUrl();
  return (
    <ServicePage
      backLabel="Audituri"
      backTo={url.dept("audituri")}
      number="02"
      eyebrow="Audit digitalizare"
      title={["Proiect informatic", "pentru digitalizare."]}
      tagline="Digitalizarea — soluția pentru afaceri eficiente și adaptabile într-o economie în care tehnologia decide viteza."
      intro={[
        "Într-o perioadă în care tehnologia evoluează cu repeziciune, digitalizarea devine un pilon esențial al succesului. Începe cu transformarea informațiilor de pe hârtie în format digital — arhivă electronică, fluxuri de lucru automate, comunicare rapidă cu clienți și angajați.",
        "Instituțiile statului au deja portaluri precum ghișeul.ro, e-guvernare.ro, Punctul de Contact Unic electronic sau SEAP. Aceeași direcție este urmată de companiile private care vor să atragă și să păstreze clienți pe termen lung.",
        "Antreprenorii care implementează noi tehnologii și oferă servicii online sigure, rapide și de calitate câștigă avantaj competitiv măsurabil. Prezența pe rețelele sociale nu este suficientă — digitalizarea trebuie să acopere toate ariile de acțiune.",
      ]}
      stepsEyebrow="Avantajele digitalizării"
      stepsTitle="Trei câștiguri directe pentru operațiuni."
      steps={[
        {
          title: "Eficiență",
          desc: "Reducerea timpului dedicat activităților repetitive și optimizarea fluxurilor de lucru zilnice.",
        },
        {
          title: "Adaptabilitate",
          desc: "Răspuns rapid la schimbările din piață și un plus de competitivitate într-un mediu în evoluție.",
        },
        {
          title: "Extindere",
          desc: "Acces la noi piețe, segmente de clienți și canale de vânzare — cu date obiective de performanță.",
        },
      ]}
      servicesEyebrow="Serviciile SUNTEC"
      servicesTitle="Un partener unic pentru digitalizare."
      services={[
        {
          title: "Consultanță și strategie",
          tags: "20+ ani experiență · analize personalizate · roadmap tehnic.",
          desc: "Cu o experiență solidă de două decenii în consultanță și implementare de soluții IT&C, ghidăm compania prin procesul de digitalizare — de la diagnostic la implementare, cu impact major asupra operațiunilor.",
        },
        {
          title: "Servicii IT&C integrate",
          tags: "Dezvoltare software · securitate cibernetică · cloud · rețele · echipamente.",
          desc: "Acoperim o gamă largă de servicii IT&C — dezvoltare de software, securitate cibernetică, servicii cloud. O abordare integrată care oferă clienților un partener unic pentru toate nevoile de digitalizare.",
        },
        {
          title: "Soluții personalizate",
          tags: "Adaptate specificului fiecărui client · optimizare procese · extindere online.",
          desc: "Fiecare companie are cerințe distincte. Oferim soluții adaptate specificului și obiectivelor fiecărui client — indiferent dacă este vorba despre optimizarea proceselor interne sau extinderea prezenței online.",
        },
        {
          title: "Comunicare digitală",
          tags: "Portal clienți · comunicare internă · productivitate · vizibilitate.",
          desc: "Digitalizarea cu SUNTEC înseamnă comunicare rapidă și clară cu clienții și angajații — ceea ce eficientizează procesele, crește productivitatea și consolidează vizibilitatea brandului.",
        },
      ]}
    />
  );
}
